import React from 'react';
import PropTypes from 'prop-types';
import HorizontalStroke from '../../assets/brush/horizontal-stroke.png';
import { ImageProps, RichTextPropTypes } from '../../prop-types';
import { Container } from '../styled/containers';
import {
  BrushElement,
  FlexWrapper,
  ImageWrapper,
  ItemWrapper,
  StyledRichText,
  TextWrapper,
  Title,
} from './styles';

const ContentBlockAltItem = ({ data, isOdd, background, decorated }) => {
  const { image, title, text } = data;
  const alignImage = data.alignImage || 'center';

  return (
    <ItemWrapper $background={background} data-testid="content-block">
      <Container>
        <FlexWrapper $isOdd={isOdd} data-testid="content-wrapper">
          <ImageWrapper $image={image} $alignImage={alignImage} />
          <TextWrapper $isOdd={isOdd} $background={background}>
            {title ? <Title>{title}</Title> : null}
            {decorated ? <BrushElement src={HorizontalStroke} alt="" /> : null}
            <StyledRichText richText={text} />
          </TextWrapper>
        </FlexWrapper>
      </Container>
    </ItemWrapper>
  );
};

ContentBlockAltItem.propTypes = {
  data: PropTypes.shape({
    image: ImageProps.isRequired,
    title: PropTypes.string,
    text: RichTextPropTypes.isRequired,
    alignImage: PropTypes.oneOf(['top', 'center', 'bottom']),
  }).isRequired,
  isOdd: PropTypes.bool.isRequired,
  decorated: PropTypes.bool.isRequired,
  background: PropTypes.string.isRequired,
};

export default ContentBlockAltItem;
